import { observer } from "mobx-react"
import { Table } from "antd"
import { CompanyExcel } from "../../../../domain/entities/CompanyExcel"
import { useTranslation } from "react-i18next"
import { currencyFormatter } from "../../../utils/currencyFormatter"

interface CompanyExcelTableProps {
	data: CompanyExcel[]
	loading?: boolean
}

const CompanyExcelTable = ({ data, loading }: CompanyExcelTableProps) => {
	const { t } = useTranslation("companyExcel")

	const columns = [
		{
			title: t("table.id"),
			dataIndex: "id",
			key: "id",
			width: 80
		},
		{
			title: t("table.date"),
			dataIndex: "createdAt",
			key: "createdAt",
			width: 180,
			render: (date: string) => new Date(date).toLocaleString()
		},
		{
			title: t("table.recordCount"),
			dataIndex: "recordsCount",
			key: "recordsCount",
			width: 150
		},
		{
			title: t("table.totalAmount"),
			dataIndex: "totalAmount",
			key: "totalAmount",
			width: 150,
			render: (amount: number) => currencyFormatter(amount, "EUR")
		},
		{
			title: t("table.microsite"),
			dataIndex: "micrositeName",
			key: "micrositeName",
			width: 200
		},
		{
			title: t("table.fileName"),
			dataIndex: "originalFilename",
			key: "originalFilename",
			width: 250
		},
		{
			title: t("table.status"),
			dataIndex: "status",
			key: "status",
			width: 120
		},
		{
			title: t("table.processedBy"),
			dataIndex: "processedByUserName",
			key: "processedByUserName",
			width: 180
		}
	]

	return (
		<Table
			columns={columns}
			dataSource={data}
			loading={loading}
			rowKey="id"
			pagination={{
				pageSize: 20,
				showSizeChanger: true,
				showTotal: (total, range) => `${range[0]}-${range[1]} ${t("table.of")} ${total}`
			}}
			scroll={{ x: 1200 }}
		/>
	)
}

export default observer(CompanyExcelTable)
